import { Injectable} from '@angular/core';
import {StateService} from '@uirouter/core';
import {WindowRefService} from "./window.service";

@Injectable()
export class FormService {
    private _window: any;
    constructor(
        windowRef: WindowRefService,
        private Location: StateService
    ) {
        this._window = windowRef.nativeWindow;
    }

    handleError(response, error, form) {
        let data = response.error || response.data;
        form.$submitting = false;
        form.$errorMsg = !data ? 'Internal error occurred' : (
            (data.message || response.statusText || 'Internal error occurred')
        );

        this.proceedErrors(form, response);
        if (error) {
            error(response);
        }
    }
    proceedErrors(form, response) {
        if (response.status === 500) {
            this.Location.go('error500');
        } else if (response.status === 401) {
            this.Location.go(form.state || 'login',{'back_uri' : this._window.encodeURIComponent(this._window.location.href)});
        }
        let errors = (response.error ? response.error.errors:null) || (response.data ? response.data.errors : null) || [];
        for(let key in errors){
            let msg = errors[key];
            if (form.form.controls[key]) {
                form.form.controls[key].setErrors({
                    remote: msg instanceof Array ? msg.join(' ') : msg
                });
            } else {
                form.$errorMsg += '<br/>' + key + ': ' + msg;
            }
        }
    }

    submit(form, submit, success, error, invalid, responseValidator) {
        form.$submitted = true;
        form.$errorMsg = null;
        var isValidResponse = responseValidator || function (response) {


            return !((response.data && response.data.code === 400) || response.status === 400 || response.code === 400);
        };
        if (form.form.$valid || form.form.valid ) {
            if (submit) {
                form.$submitting = true;
                submit(form).then( (response) => {
                    if (!isValidResponse(response)) {
                        this.handleError(response, error, form);
                    } else {
                        form.$submitting = false;
                        if (success) {
                            success(response);
                        }
                    }
                },  (response) =>{
                    this.handleError(response, error, form);
                });
            } else {
                form.$submitting = false;
                if (success) {
                    success();
                }
            }
        } else {
            form.$errorMsg = 'Please provide the required information and correct the mistakes';
            if (invalid) {
                invalid();
            }
        }
    }

}